'use strict';

let moduleName = 'menu-catalog';

module.exports = function () {
	$('[js-menu-catalog]').each(function () {
		if ($.data(this, moduleName + '-init')) return;
		$.data(this, moduleName + '-init', true);



		let $menu 		   = $(this),
			$btnDropDown   = $menu.find('[js-menu-catalog-link-drop-down]'),
			$btnInDropDown = $menu.find('[js-menu-catalog-link-in-drop-down]');



		$('html').on('mouseover touchstart click', function() {
			$btnDropDown.removeClass('active');
			$btnInDropDown.removeClass('active');
		});



		$menu.on('mouseover touchstart click', function(e) {
			e.stopPropagation();
		});



		$btnDropDown.on('mouseover touchstart click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			let $btn = $(this);

			toggleMenu($btn);
		});



		$btnInDropDown.on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			let $btn = $(this);

			toggleMenuIn($btn);
		});



		$('.catalog-menu-list__link').on('mouseover touchstart click', function() {
			if (!($(this).is('[js-menu-catalog-link-drop-down]'))) {
				$btnDropDown.removeClass('active');
			}
		});
 


		function toggleMenu($btn) {
			$btn.toggleClass('active');
			$btnInDropDown.removeClass('active');

			$btnDropDown.not($btn).each(function() {
				$(this).removeClass('active');
			});
		}



		function toggleMenuIn($btn) {
			$btn.toggleClass('active');

			$btnInDropDown.not($btn).each(function() {
				$(this).removeClass('active');
			});
		}



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/menuCatalogInit.js
 **/